<template>
    <section class="home-container">
        <MasterPage title="预约管理">
            <div slot="title-icon">
                <Icon type="ios-pulse" />
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="100">
                    <Row>
                        <Col span="12">
                        <FormItem label="医生姓名：">
                            <Input v-model="select.name" placeholder="请输入" />
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="医生职称：">
                            <Input v-model="select.title" placeholder="请输入" />
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="医生专长：">
                            <Input v-model="select.profession" placeholder="请输入" />
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="预约时间段：">
                            <DatePicker v-model="select.dataTime" type="datetimerange" format="yyyy-MM-dd HH:mm" placeholder="请选择预约时间段" style="width: 100%"></DatePicker>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="search">
                <Button type="primary" icon="md-add" @click="addItem_modal">添加</Button>
            </div>
            <div slot="btns">
                <Button type="info" icon="ios-search" @click="pageFindItem">查询</Button>
            </div>
            <div slot="paddingContent">
                <Table stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <div slot="pager">
                <Page :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageSize" show-total show-elevator show-sizer/>
            </div>
        </MasterPage>
        <Modal v-model="addModel" title="新增预约" width="800" @on-cancel="cancelItemTime">
            <Form :label-width="80">
                <Row
                    v-for="(doctorTime,index) in doctorTimeList"
                    :key="doctorTime.key">
                    <Col span="7">
                    <FormItem label="预约医生：">
                        <Select v-model="doctorTime.doctorId" placeholder="请选择">
                            <Option v-for="item in doctorAllList"  :value="item.id" :key="item.id">
                                {{ item.name }}
                            </Option>
                        </Select>
                    </FormItem>
                    </Col>
                    <Col span="7">
                    <FormItem label="预约时间：">
                        <DatePicker v-model="doctorTime.time" type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择预约时间段" style="width: 100%"></DatePicker>
                    </FormItem>
                    </Col>
                    <Col span="7">
                    <FormItem label="预约患者：">
                        <Select v-model="doctorTime.userId"  placeholder="请选择">
                            <Option v-for="item in userAllList" :value="item.id" :key="item.id">
                                {{ item.name }}
                            </Option>
                        </Select>
                    </FormItem>
                    </Col>
                    </Col>
                    <Col span="2" offset="1">
                    <Button @click="handleRemove(index)">删除</Button>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                    <FormItem>
                        <Button type="dashed" long @click="handleAdd" icon="md-add">添加新的患者预约</Button>
                    </FormItem>
                    </Col>
                </Row>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItemTime">取消</Button>
                <Button type="primary" size="large" :loading="addLoading" @click="addItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="updateModel" title="修改预约" width="800" @on-cancel="cancelItem">
            <Form :label-width="90">
                <Row>
                    <Col span="8">
                    <FormItem label="预约医生：">
                        <Select v-model="updateInfoItem.doctorId" placeholder="请选择">
                            <Option v-for="item in doctorAllList"  :value="item.id" :key="item.id">
                                {{ item.name }}
                            </Option>
                        </Select>
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="预约时间：">
                        <DatePicker v-model="updateInfoItem.time" type="datetime"  placeholder="请选择预约时间段" style="width: 100%"></DatePicker>
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="预约患者：">
                        <Select v-model="updateInfoItem.userId"  placeholder="请选择">
                            <Option v-for="item in userAllList" :value="item.id" :key="item.id">
                                {{ item.name }}
                            </Option>
                        </Select>
                    </FormItem>
                    </Col>
                </Row>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="updateLoading" @click="updateItem">确定</Button>
            </div>
        </Modal>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    export default {
        components:{
            MasterPage
        },
        data(){
            return{
                columns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                    {
                        title: '医生姓名',
                        key: 'name',
                        align: 'center',
                    },
                    {
                        title: '医生职称',
                        key: 'title',
                        align: 'center',
                    },
                    {
                        title: '医生专长',
                        key: 'profession',
                        tooltip:true,
                        align: 'center',
                    },
                    {
                        title: '预约时间',
                        align: 'center',
                        minWidth:50,
                        render:(h, params) =>{
                            let time = new Date(params.row.time)
                            let y = time.getFullYear();
                            let m = (time.getMonth()+1) < 10 ? '0' + (time.getMonth()+1):(time.getMonth()+1);
                            let d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
                            let hx = time.getHours()< 10 ? '0' + time.getHours() : time.getHours()
                            let mm = time.getMinutes()< 10 ? '0' + time.getMinutes() : time.getMinutes()
                            let s = time.getSeconds()< 10 ? '0' + time.getSeconds() : time.getSeconds()
                            return h("span",y+'-'+m+'-'+d+' '+hx+':'+mm+':'+s)
                        }
                    },
                    {
                        title: '预约患者',
                        align: 'center',
                        render:(h, params) =>{
                            return h("span",params.row.user.name)
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        minWidth:150,
                        render: (h, params) => {
                            let Buttons = []
                            if (this.dataList[params.index].isDeleted){
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-unlock',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.reuseItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '启用')
                                )
                            }else{
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-create',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.updateItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '编辑')
                                )
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            icon:'md-trash',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.deleteItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '禁用')
                                )
                            }
                            return h("div",Buttons)
                        }
                    }
                ],
                dataList: [],
                tableLoading:false,
                addModel:false,
                addLoading:false,
                updateModel:false,
                updateLoading:false,
                userAllList:[],
                doctorAllList:[],
                select:{
                    name:'',
                    title:'',
                    profession:'',
                    dataTime:'',
                },
                doctorTimeList:[],
                key:0,
                updateInfoItem:{},
                pageNum:1,
                pageSize:20,
                pageTotal:0,
            }
        },
        created(){
            this.pageFindItem()
            this.findAllUser()
            this.findAllDoctor()
        },
        methods:{
            dateTimeToStrings (dateTime) {
                let time = new Date(dateTime)
                let y = time.getFullYear();
                let m = (time.getMonth()+1) < 10 ? '0' + (time.getMonth()+1):(time.getMonth()+1);
                let d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
                let h = time.getHours()< 10 ? '0' + time.getHours() : time.getHours()
                let mm = time.getMinutes()< 10 ? '0' + time.getMinutes() : time.getMinutes()
                let s = time.getSeconds()< 10 ? '0' + time.getSeconds() : time.getSeconds()
                return y+'/'+m+'/'+d+' '+h+':'+mm+':'+s;
            },
            pageChange(value){
                this.pageNum = value
                this.pageFindItem()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindItem()
            },
            handleAdd(){
                this.doctorTimeList.push({time:'',userId:'',doctorId:'',key:this.key,createUser:this.$store.state.systemUser.loginName})
                this.key++
            },
            handleRemove(index){
                this.doctorTimeList.splice(index, 1)
            },
            cancelItemTime(){
                this.cancelItem()
                this.key = 0
                this.doctorTimeList.length  = 0
            },
            findAllUser(){
                this.$http.post('user/list',{
                    isLock:false,
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.userAllList = msg.data.list
                    }else {
                        this.$Notice.error({title:'患者账户查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            findAllDoctor(){
                this.$http.post('doctor/list',{
                    isDeleted:false,
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.doctorAllList = msg.data.list
                    }else {
                        this.$Notice.error({title:'医生列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            pageFindItem(){
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('doctor/doctorTimeList',{
                    name:this.select.name,
                    title:this.select.title,
                    profession:this.select.profession,
                    startTime:this.select.dataTime[0] == undefined || this.select.dataTime[0] == "" ? new Date(undefined):this.select.dataTime[0]+"",
                    endTime:this.select.dataTime[1] == undefined || this.select.dataTime[1] == "" ? new Date(undefined):this.select.dataTime[1]+"",
                    pageSize:this.pageSize,
                    pageNum:this.pageNum,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data.list
                        this.pageTotal = msg.data.total
                    }else {
                        this.$Notice.error({title:'预约列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            addItem_modal(){
                this.handleAdd()
                this.addModel=true
            },
            addItem(){
                let falg = false
                data:for(let index in this.doctorTimeList){
                    for(let key in this.doctorTimeList[index]){
                        if (this.doctorTimeList[index][key].length <=0) {
                            falg = true
                            break data
                        }
                    }
                }
                if (falg){
                    return this.$Message.warning('请填写完整数据')
                }
                this.addLoading = true
                this.$http.post('doctor/addDoctorTime',
                    this.doctorTimeList,
                {emulateJSON:false}).then(function (res) {
                    this.cancelItemTime()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '新增预约成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'新增预约失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItemTime()
                    this.myError(res.body)
                })
            },
            updateItem_modal(item){
                this.updateInfoItem = {id:item.timeId,doctorId:item.id,userId:item.user.id,isDeleted:false,time:this.dateTimeToStrings(item.time)}
                this.updateModel = true
            },
            updateItem(){
                if (this.updateInfoItem.doctorId.length <= 0){
                    return this.$Message.warning('请选择医生');
                }
                if (this.updateInfoItem.time.length <= 0){
                    return this.$Message.warning('请选择预约时间');
                }
                if (this.updateInfoItem.userId.length <= 0){
                    return this.$Message.warning('请选择患者');
                }
                this.updateLoading = true
                this.$http.post('doctor/updateDoctorTime',
                    this.updateInfoItem,
                {emulateJSON:false}).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '修改预约成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'修改预约失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            cancelItem(){
                this.addModel = this.addLoading = this.updateModel = this.updateLoading = false
            },
            deleteItem_modal(item){
                this.$Modal.confirm({
                    title: '确认禁用医生“'+ item.name + '”',
                    loading:true,
                    onOk: () => {
                        this.deleteItem(item);
                    }
                });
            },
            deleteItem(item){
                this.$http.post('doctor/deleteDoctorTime',{
                    id:item.timeId,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '医生禁用成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'医生禁用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    .home-container{

    }
</style>
